"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setCustomerToken = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const constants_1 = require("../../constants/index.js");
/**
 * @function setCustomerToken
 * @description Adiciona o token como um cookie no navegador.
 */
const setCustomerToken = (token) => {
    js_cookie_1.default.set(constants_1.CUSTOMER_TOKEN_KEY, token);
};
exports.setCustomerToken = setCustomerToken;
